import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import React, { forwardRef } from 'react';
import { ellipsis } from '../../styles/utilities.css';
import { Layout } from '../Layout/Layout';
import * as styles from './Item.css';

export type Key = number | string;

export interface ItemProps {
  readonly id?: string;
  readonly className?: string;
  readonly secondaryTextValue?: string;
  readonly value: Key;
  readonly disabled?: boolean;
  readonly drawer?: boolean;
  readonly focused?: boolean;
  readonly selected?: boolean;
  readonly onAction?: (item: Key) => void;
  readonly role?: string;
}

export const Item = forwardRef<HTMLDivElement, PropsWithChildren<ItemProps>>(
  (
    {
      disabled = false,
      children,
      drawer = false,
      secondaryTextValue,
      focused,
      id,
      selected,
      className,
      onAction,
      value,
      role,
    },
    ref,
  ) => (
    <Layout
      className={clsx(
        styles.selectItem({
          drawer,
          focused,
          selected,
          secondaryLabel: Boolean(secondaryTextValue),
          disabled,
        }),
        ellipsis,
        className,
      )}
      id={id}
      onClick={() => !disabled && onAction?.(value)}
      ref={ref}
      role={role}
    >
      {children}
    </Layout>
  ),
);
